import { render } from "./RecordLabel.vue?vue&type=template&id=f31ce07e"
import script from "./RecordLabel.vue?vue&type=script&lang=js"
export * from "./RecordLabel.vue?vue&type=script&lang=js"

import "./RecordLabel.vue?vue&type=style&index=0&id=f31ce07e&lang=css"

import exportComponent from "C:\\Users\\Sabir\\Downloads\\Subrogation-Progress\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__